export default {"src":"/_next/static/image/public/images/ic_facility_selected.f89e8fd7c2a6f11d4221bed79703f750.svg","height":28,"width":28};